import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import routes from './routes'; // Your routes definition file
import Layout from './Layout'; // Your routes definition file
import PublicLayout from './PublicLayout';
import AuthService from '../services/AuthService'; // Your AuthService
import { selectStoredPermissions } from '../stores/permissionsSlice';



const AppRouter = () => {
    const isAuthenticated = AuthService.getCurrentUser();
    const basePath= process.env.REACT_APP_BASE_PATH;

    return (
        <Router  basename={basePath} >
            <Routes>
                {routes.map((route, index) => {
                    const Component = route.component;
                    // Check authentication and permissions
                    const requiresAuth = route.meta.requiresAuth;
                    let hasPermission = true;
                    // if (route.meta.permission) {
                    //     hasPermission = selectStoredPermissions().includes(route.meta.permission);
                    // }
                    const hideHeader = route.meta.hideHeader;
                    const LayoutComponent = route.meta.layout === 'public' ? PublicLayout : Layout;

                    return (
                        <Route
                            key={index}
                            path={route.path}
                            element={
                                requiresAuth && !isAuthenticated ? (
                                    <Navigate to="/login" />
                                ): (
                                    <LayoutComponent hideHeader={hideHeader} hasPermission={hasPermission}  >
                                        <Component  />
                                    </LayoutComponent>
                                )
                            } 
                        />
                    );
                })}
            </Routes>
        </Router>
    );
};

export default AppRouter;
